import { render, staticRenderFns } from "./DetailRiwayatRekonsiliasi.vue?vue&type=template&id=a0b07a7e"
import script from "./DetailRiwayatRekonsiliasi.vue?vue&type=script&lang=js"
export * from "./DetailRiwayatRekonsiliasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports